import { renderPage } from "app/renderPage"
import { UserSecurityLoginPage } from "./Page"

renderPage({ component: UserSecurityLoginPage })
